module.exports = __webpack_public_path__ + "assets/img/img77.b70012c6.png";